<template>
<div class="gate-image-uploader">
  <div class="cropper-wrap">
    <vue-cropper
      v-if="imageInfo && imageInfo.blob"
      ref="cropper"
      :aspectRatio="9 / 9"
      :src="imageInfo.blob"
      :viewMode="2"
      :autoCropArea="1"/>
  </div>
  <upload-component
    ref="uploader"
    :value="image"
    @input="onUpload"
    @input-filter="uploadFilter"
    :multiple="false"
    accept="image/*">
    <b-button type="blue-btn">Upload image</b-button>
  </upload-component>
  <div class="image-uploader-info">
    <div class="image-uploader-info-title">
      <div class="icon">
        <i style="color: #666; margin-right: 8px" class="fak fa-circle-info-light"/>
      </div>
      <div class="text">
        <p>Reward image requirements</p>
      </div>
    </div>
    <div class="image-uploader-info-body">
      <ul>
        <li>• The file size must be less than 25 MB</li>
      </ul>
    </div>
  </div>
</div>
</template>
<script>
import Vue from 'vue'
import VueCropper from "vue-cropperjs";
import BButton from "@/components/__new_ui_kit/Button/BButton";
import UploadComponent from "vue-upload-component";
import api_requests from "../../store/api/api_requests";
export default Vue.extend({
  components: {
    BButton,
    VueCropper,
    UploadComponent
  },
  props: {
    image: {
      type: Array
    }
  },
  computed: {
    imageInfo() {
      return (this.image && this.image.length) ? this.image[0] : null
    }
  },
  watch: {
    imageInfo(v) {
      this.$emit('is-set-image', v.blob)
    }
  },
  methods: {
    onUpload(value) {
      this.$emit('on-upload', value)
    },
    uploadFilter(newImage, oldImage) {
      newImage.blob = URL.createObjectURL(newImage.file)
      if (this.$refs?.cropper?.replace) this.$refs.cropper.replace(newImage.blob)
    },
    saveImage() {
      return new Promise((resolve, reject) => {
        this.$refs.cropper.getCroppedCanvas({width: 1280, height: 720}).toBlob((blob) => {
          let data = new FormData();
          data.append('img', blob, 'cropped.png')
          api_requests.upload_reward_img(data)
              .then(response => {
                this.$emit('reward-image-set', response.data.path)
                resolve(response);
              })
              .catch(error => {
                reject(error)
              })
        })

      })
    }
  }
})
</script>
<style lang="scss" scoped>;
.gate-image-uploader {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  .cropper-wrap {
    max-width: 100%;
    @media(max-width: 640px) {
      width: 100%;
    }
  }
  .image-uploader-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 16px;
    gap: 6px;
    &-title {
      display: flex;
      align-items: flex-start;
      p {
        margin-top: 3px;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
      }
    }
    &-body {
      ul {
        li {
          margin-top: 3px;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }
  }
}
</style>